/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Cancel_ActivityInputs */

const en_task_cancel_activity = /** @type {(inputs: Task_Cancel_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel activity`)
};

const pt_br2_task_cancel_activity = /** @type {(inputs: Task_Cancel_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar atividade`)
};

/**
* | output |
* | --- |
* | "Cancel activity" |
*
* @param {Task_Cancel_ActivityInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_cancel_activity = /** @type {((inputs?: Task_Cancel_ActivityInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Cancel_ActivityInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_cancel_activity(inputs)
	return pt_br2_task_cancel_activity(inputs)
});